import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnChanges,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { IconComponent } from '@shared/lib/components/ui/icon/icon.component';
import { ModalComponent } from '@shared/lib/components/ui/modal/modal.component';
import { CoreModule } from '@shared/lib/modules/core.module';
import { DeploymentStore } from '@shared/lib/stores/deployment.store';
import { ButtonDirective } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ods-modal-single-select',
    templateUrl: './single-select.component.html',
    imports: [CoreModule, ButtonDirective, ModalComponent, IconComponent, InputTextModule]
})
export class SingleSelectComponent implements OnInit, OnChanges {
  isTenantSelection = input<boolean>(true);
  isModalVisible = signal(false);

  useStore = input<boolean>(true);
  currentValue = input<any>();
  disabled = input<boolean>(false);
  readonly outputValue = output<any>();

  deploymentStore = inject(DeploymentStore);
  searchData = computed(() => this.isTenantSelection() ? this.deploymentStore.tenantList() : this.deploymentStore.deploymentList());
  filteredItems = signal<any[]>([]);

  selectedName = computed(() => {
    if (this.useStore()) {
      if (this.isTenantSelection()) {
        return this.deploymentStore.selectedTenant()?.name ?? '--';
      } else {
        return this.deploymentStore.selectedDeployment()?.name ?? '--';
      }
    } else {
      return this.currentValue() ?? '--';
    }
  })

  ngOnChanges() {
    this.filteredItems.set(this.searchData() ?? []);
  }

  ngOnInit() {
    this.filteredItems.set(this.searchData() ?? []);
  }

  hideModal() {
    this.isModalVisible.set(false);
  }

  filterList(searchQuery: any | undefined) {
    /**
     * If no search query is defined,
     * return all options.
     */
    if (searchQuery === undefined) {
      this.filteredItems.set(this.searchData() ?? []);
    } else {

      /**
       * Otherwise, normalize the search
       * query and check to see which items
       * contain the search query as a substring.
       */
      const normalizedQuery = searchQuery.target?.value.toLowerCase();
      this.filteredItems.set(this.searchData()?.filter((item) => {
        return item.name?.toLowerCase().includes(normalizedQuery) || item.id.toString().includes(normalizedQuery);
      }) ?? []);
    }
  }

  setSelection(item: any) {
    if (this.useStore()) {
      if (this.isTenantSelection()) {
        this.deploymentStore.setTenant(item.id)
      } else {
        this.deploymentStore.setDeployment(item.id)
      }
    }
    else {
      this.outputValue.emit(item);
    }
    this.hideModal();
  }
}
